export default __webpack_public_path__ + "static/media/dstv.0f7c85a8.svg";